<template>
<div class="text-xs-center">
  <v-dialog
    :value="show"
    width="500"
  >
    <v-card>
      <v-card-title>Toggl Configuration</v-card-title>
      <v-card-text>
        <v-stepper v-model="step">

          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">API Key</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2">Workspace</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3">Complete</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <p>You can find your API key on your toggl profile page.</p>
              <v-text-field
                :value="togglApiKey"
                :error="apiKeyError"
                :error-messages="apiKeyErrors"
                label="API Key"
                placeholder="API Key"
                @change="setTogglApiKey"
              ></v-text-field>

              <v-btn
                color="primary"
                @click="gotoStep2"
              >Continue</v-btn>
              <v-btn flat @click="$emit('cancel')">Cancel</v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
              <p>Please select which workspace you want to use.</p>
              <v-radio-group value="workspaceId" @change="setTogglWorkspaceId">
                <v-radio
                  v-for="w in workspaces"
                  :key="w.id"
                  :label="w.name"
                  :value="w.id"
                ></v-radio>
              </v-radio-group>
              <v-btn
                color="primary"
                :disabled="!togglWorkspaceId"
                @click="step = 3"
              >Continue</v-btn>
              <v-btn flat @click="$emit('cancel')">Cancel</v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
              <p>Your timers will be stored in Workspace: <template v-if="workspace"> {{ workspace.name }}</template></p>
              <v-btn
                color="primary"
                @click="finishConfig"
              >Finish</v-btn>
              <v-btn flat @click="$emit('cancel')">Cancel</v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from 'axios';

export default {
  name: 'TheToggleConfigurator',
  props: {
    show: Boolean
  },
  data() {
    return {
      apiKey: null,
      active: false,
      workspaceId: null,
      step: 0,
      workspaces: [],
      apiKeyError: false,
      apiKeyErrors: []
    }
  },
  computed: {
    workspace() {
      if (this.workspaces.length > 0) {
        let index = this.workspaces.findIndex(w => w.id == this.togglWorkspaceId);
        return this.workspaces[index];
      }
      return null;
    },
    ...mapGetters([
      "togglApiKey",
      "togglIntegrationActive",
      "togglWorkspaceId",
    ])
  },
  mounted() {
    this.apiKey = this.togglApiKey;
    this.active = this.togglIntegrationActive;
    this.workspaceId = null;
    this.step = 1;
  },
  watch: {
    show(n, o) {
      if (n) {
        this.step = 1;
      }
    },
  },
  methods: {
    async gotoStep2() {
      let vm = this;
      let result = null;
      console.log("checking with key", vm.togglApiKey);
      try {
        result = await axios.get('https://www.toggl.com/api/v8/workspaces', {
          auth: {
            password: 'api_token',
            username: vm.togglApiKey
          }
        });
      } catch (error) {
        this.apiKeyError = true;
        this.apiKeyErrors = [ "This API does not appear to be valid" ];
        return;
      }
      console.log(result);
      this.apiKeyError = false;
      this.apiKeyErrors = [];
      if (result.hasOwnProperty('status') && result.status == 200) {
        if (result.hasOwnProperty('data') && result.data.length > 0) {
          vm.workspaces = result.data;
          vm.step = 2;
        }
      } else {
        console.error("invalid toggl response")
      }
    },
    finishConfig() {
      this.setTogglIntegrationActive(true);
      this.$emit('done', true);
    },
    ...mapActions([
      "setTogglApiKey",
      "setTogglWorkspaceId",
      "setTogglIntegrationActive",
    ])
  },
}
</script>
